import PropTypes from 'prop-types';

const SelectListDataPropType = PropTypes.shape({
  text: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export default SelectListDataPropType;
